export default "__VITE_ASSET__f90bafe8__"